import { IPart } from "../../../models/Part";
import { computeEbayListingTitle } from "../EbayListingTitle";

export type ListingWorkflowStep = {
  id: string;
  label: string;
  done: boolean;
  detail?: string;
};

const EBAY_TITLE_MAX = 80;

export function getListingWorkflowSteps(part: IPart): ListingWorkflowStep[] {

  const mergedTitle = (computeEbayListingTitle(part) ?? "").trim();
  const offerTitle = part.offers?.[0]?.title?.trim() ?? "";
  const effectiveTitle = mergedTitle || offerTitle;
  const titleLen = effectiveTitle.length;
  const titleConfigured = Boolean(part.titleConfigured);
  const titleDetail =
    titleConfigured
      ? undefined
      : titleLen === 0
      ? "No title set"
      : titleLen > EBAY_TITLE_MAX
        ? `Title is ${titleLen}/${EBAY_TITLE_MAX} chars — shorten to fit`
        : "Click to confirm title is configured";

  const hasImages = Array.isArray(part.images) && part.images.length > 0;

  const mpn = (part.oePartNumber ?? part.partNumber ?? "").trim();
  const mpnAdded = mpn.length > 0;

  const hasPrice = Boolean(
    (part.offers?.[0]?.buyItNowPrice ?? 0) > 0 ||
    (part.offers?.[0]?.auctionStartPrice ?? 0) > 0 ||
    (part.enteredPrice ?? 0) > 0
  );

  const hasSpecifics = Boolean(
    Array.isArray(part.aspects) &&
    part.aspects.length > 0 &&
    part.aspects.every((aspect) => !aspect.isRequired || aspect.value)
  );

  return [
    {
      id: "title",
      label: "Title Configured",
      done: titleConfigured,
      detail: titleDetail,
    },
    {
      id: "images",
      label: "Images",
      done: hasImages,
      detail: hasImages ? undefined : "Add at least one image",
    },
    {
      id: "price",
      label: "Price",
      done: hasPrice,
      detail: hasPrice ? undefined : "Set a valid listing price",
    },
    { id: "mpn", label: "MPN Added", done: mpnAdded },
    {
      id: "specifics",
      label: "Specifics",
      done: hasSpecifics,
      detail: hasSpecifics ? undefined : "Review required item specifics",
    },
  ];
}
